module.exports = __webpack_public_path__ + "media/images/common/ico-like-on-8f2206096fc086767a19cf403b878c7a.svg";